import { parse, format } from 'date-fns';
import { set, get} from "@Core/LocalStorage";
const CommonFunction = {
  validateEmail: function (email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/);
  },
  capitalizeString: function (string) {
    return string && string.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  },
  tConvert: function (time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];
    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string 
  },
  dateFormatter: function (inputDate) {
    const parsedDate = parse(inputDate, 'yyyyMMddHHmmss', new Date());
    const formattedDate = format(parsedDate, 'dd/MM/yyyy');
    return formattedDate;
  },
  mobileFormatter: function (mob) {
    return mob.replace(/^.{1,7}/, m => "X".repeat(m.length))
  },
  addDays: function (date, days) {
    days = parseInt(days)
    let tempDate = new Date(date)
    tempDate.setDate(tempDate.getDate() + days)
    return tempDate
  },
  maskPhoneNumber: function(phoneNumber) {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '******$3');
  },
  maskEmail: function(email) {
    return email.replace(/(.)(.*)(?=@)/, (match, firstChar, rest) => firstChar + '*'.repeat(rest.length));
  },
  updateSrmwuiCustomerObj: function(key, value) {
    const existing =  get('srmwuiCustomerObj') || {}
    let newValue = value;
    // ----------- If existing key is an object → merge it -----------
    if (typeof existing[key] === "object" && !Array.isArray(existing[key])) {
      newValue = { 
        ...existing[key], 
        ...value 
      };
    }
    const updated = {
      ...existing,
      [key]: newValue,
    };
    set('srmwuiCustomerObj', updated) 
  },
  deleteFromSrmwuiCustomerObj: function(key) {
    const existing =  get('srmwuiCustomerObj') || {}
   // 2. Delete the key safely
   if (existing.hasOwnProperty(key)) {
    delete existing[key];
  }
    set('srmwuiCustomerObj', existing) 
  }
}

export default CommonFunction